'use client'

import styled from 'styled-components'

export const PreviewMode = styled.div`
  ${({
    theme: {
      base: {
        shade: { orange },
      },
    },
  }) => `
    display: flex;
    position: fixed;
    align-items: center;
    position: fixed;
    bottom: 100px;
    left: 0;
    gap: 10px;
    font-size: 1rem;
    padding: 1rem;
    font-weight: 700;
    z-index: 9999;
    color: color-mix(in lch, ${orange[1]}, black);
    width: 200px;
    height: 80px;
    background-color: ${orange[1]}99;
    border-radius: 0 50px 50px 0;
  `}
`
